import type { ReactNode } from 'react'
import React from 'react'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'

interface AnswersListWrapperProps {
  className?: string
}

export const AnswersListWrapper = ({
  className,
  children,
}: React.PropsWithChildren<AnswersListWrapperProps>): ReactNode => {
  return (
    <ul
      className={`mt-6 grid grid-cols-1 flex-wrap items-start gap-4 lg:grid-cols-1 lg:gap-4 xl:grid-cols-3 xl:gap-5 ${className || ''} ${addPublicCustomClassNamePrefix('course-quiz__answer-list')}`}
    >
      {children}
    </ul>
  )
}
